import React from 'react'
import SuccessIMG from '../../theme/assets/img/success.png'

export default function CompleteExam() {
  return (
    <>
    <div class="container-xxl container-p-y d-flex h-80vh align-items-center justify-content-center text-center ">
      <div class="misc-wrapper">
        <h2 class="mb-1 mt-4">Exam Submitted.</h2>
        <p class="mb-4 mx-2">Great! Your exam has been sumbitted.</p>
        <a href={process.env.REACT_APP_EXAM_SUCCESS_URL} class="btn btn-primary mb-4 waves-effect waves-light">Back to home</a>
        <div class="mt-4">
          <img src={SuccessIMG} alt="page-misc-error" width="225" class="img-fluid" />
        </div>
      </div>
    </div>
    </>
  )
}
